
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-464dd13f&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./newPremadeModal.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./newPremadeModal.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-464dd13f!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./newPremadeModal.vue"),
  /* scopeId */
  "data-v-464dd13f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/newPremadeModal/newPremadeModal.vue
// module id = 1388
// module chunks = 61